export const cityPath = (city) => {
  return `/service-areas/${city.id}`
}
